$(document).ready(function() {
    $(document).on('click', '.entry-summary .cart .quantity-wrapper .input-group button', function() {
        var old_value = parseInt($(this).closest('.input-group').find('.qty').val());
        var new_value = 1;

        if ($(this).hasClass('minus')) {
            if (old_value != 0)
                new_value = old_value - 1;
            else
                new_value = 0;
        } else {
            new_value = old_value + 1;
        }

        $(this).closest('.input-group').find('.qty').val(new_value);

        return false;
    });

    $('.product-upsells .owl-carousel, .product-related-products .owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        dots: true,
        margin: 30,
        responsive:{
            480:{
                items:1
            },
            767:{
                items:2
            },
            991:{
                items:3
            },
            1159:{
                items:4,
            },
        }
    });
});